<template>

<div class='col-12'>
    <div class="alert alert-info">
        Тази стъпка е прескочена от администратор на Видеа.
    </div>
</div>

</template>

<script>
    export default {

        mounted() {

        },

        created() {
           
        },

        data() {
            return {
                isReady : false,
            }
        },

        methods : {

        }

    }
</script>
